import { I18n } from "@assets/strings";
import React from "react";
import styled from "styled-components";
import disbursmentImage from "@assets/images/disbursment_image.svg";
import { Group } from "@domain/group/group";
import { useDisbursementLists } from "@domain/wallet/hook";
import { useModalTools } from "@ui/modals/modalContext";
import { DisbursementTable } from "@ui/components/wallet/disbursementTable";
import { EmptyTable } from "@ui/components/wallet/EmptyTable";
import { SeeMoreDisbursement } from "@ui/components/group/shareroom/dashboard/seemore/seemoreDisbursement";

interface LastDisbursementProps extends React.HTMLAttributes<HTMLDivElement> {
	shareroom: Group;
}
export const LastDisbursement: React.FC<LastDisbursementProps> = ({ shareroom }) => {
	const { createModal } = useModalTools();
	const { result: disbursementList } = useDisbursementLists(shareroom.id);
	return (
		<>
			<ContainerDescription>
				<StyledTitle>{I18n.t("shareroom.dashboard.transactions.cashout.title")}</StyledTitle>
				<StyledDescription>{I18n.t("shareroom.dashboard.transactions.cashout.description")}</StyledDescription>
			</ContainerDescription>
			{disbursementList?.length === 0 ? (
				<EmptyTable disbursement source={disbursmentImage} />
			) : (
				<ContainerDisbursement>
					<ShowMore onClick={() => createModal((close) => <SeeMoreDisbursement shareroom={shareroom} close={close} />)}>
						{I18n.t("see_more")}
					</ShowMore>

					<DisbursementTable shareroom={shareroom} disbursementList={disbursementList} />
				</ContainerDisbursement>
			)}
		</>
	);
};

const ContainerDescription = styled.div`
	margin-top: 39px;
	margin-left: 39px;
	margin-bottom: 30px;
`;

const StyledTitle = styled.div`
	font-weight: 600;
	font-size: 20px;
	line-height: 26px;
`;

const StyledDescription = styled.div`
	font-weight: 400;
	font-size: 14px;
	line-height: 26px;
`;
const ContainerDisbursement = styled.div`
	display: flex;
	flex-direction: column;
`;
const ShowMore = styled.div`
	display: flex;
	justify-content: flex-end;
	${({ theme }) => theme.textStyles.text};
	color: ${({ theme }) => theme.colors.secondary};
	cursor: pointer;
	margin-right: 91px;
`;
